
import * as yup from 'yup';

export const positionSchema = yup.object({
    occupationalLevelId: yup.number().typeError("Occupational Level is required").required("Occupational Level is required"),
    employeeTypeId: yup.number().typeError("Employment Type is required").required("Employment Type is required"),
    startDate: yup.date()   
    .nullable()
    .transform((curr, orig) => orig === '' ? null : curr),

    endDate: yup.date()   
    .nullable()
    .transform((curr, orig) => orig === '' ? null : curr)
})